import { render, staticRenderFns } from "./dstr-gst-invoice.vue?vue&type=template&id=5402b272"
import script from "./dstr-gst-invoice.vue?vue&type=script&lang=js"
export * from "./dstr-gst-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports